import React from 'react';

// color option type
interface ColorOption {
  name: string;
  value: string;
}

interface GaugeColorPickerProps {
  onColorChange: (colorValue: string) => void; // Just returns the selected color
}

export class GaugeColorPicker extends React.Component<
  GaugeColorPickerProps,
  {
    isOpen: boolean;
  }
> {
  constructor(props: GaugeColorPickerProps) {
    super(props);
    this.state = {
      isOpen: true // Start with the picker open
    };
  }

  // Predefined color options
  colorOptions: ColorOption[] = [
    { name: 'Gray', value: 'var(--newDolphin)' },
    { name: 'Red', value: 'var(--BernRed)' },
    { name: 'Yellow', value: 'var(--BananaClan)' },
    { name: 'Green', value: 'var(--GreenApple)' }
  ];

  selectColor = (color: ColorOption, e: React.MouseEvent) => {
    e.stopPropagation();
    
    if (this.props.onColorChange) {
      this.props.onColorChange(color.value);
    }
    
    this.setState({ isOpen: false });
  }

  handleClickOutside = (e: MouseEvent) => {
    if (this.state.isOpen) {
      this.setState({ isOpen: false });
    }
  }

  componentDidMount() {
    // Add global click listener to close picker when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    // Remove the listener when component unmounts
    document.removeEventListener('click', this.handleClickOutside);
  }

  render() {
    return (
      <div className="gauge-color-picker-container" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
        {/* Color picker popup */}
        <div className="color-picker-popup">
          {this.colorOptions.map((color, index) => (
            <div 
              key={index}
              className="color-option"
              style={{ backgroundColor: color.value }}
              onClick={(e: React.MouseEvent) => this.selectColor(color, e)}
              title={color.name}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default GaugeColorPicker;